var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildingLine = function SvgBuildingLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.6 18.3h1.8v1.8H2.6v-1.8h1.8V4.8a.9.9 0 0 1 .9-.9h9a.9.9 0 0 1 .9.9v13.5h3.6v-7.2H17V9.3h2.7a.9.9 0 0 1 .9.9zM6.2 5.7v12.6h7.2V5.7zM8 11.1h3.6v1.8H8zm0-3.6h3.6v1.8H8z"
  })));
};
export default SvgBuildingLine;